import { selectedSidebarFiltersAtom } from '@pages/VendorsSearch/containers/FilterPills/components/Sidebar/atoms';
import { useAtom } from 'jotai';
import { useCallback } from 'react';

export const useToggleSidebarFilter = () => {
	const [selectedSidebarFilters, setSelectedSidebarFilters] = useAtom(
		selectedSidebarFiltersAtom,
	);

	return useCallback(
		(value: string) => {
			if (selectedSidebarFilters.includes(value)) {
				setSelectedSidebarFilters(
					selectedSidebarFilters.filter((item) => item !== value),
				);
			} else {
				setSelectedSidebarFilters([...selectedSidebarFilters, value]);
			}
		},
		[selectedSidebarFilters, setSelectedSidebarFilters],
	);
};
